import React from "react"
import PropTypes from "prop-types"

/* eslint-disable */

const Facebook = ({ color, ...props }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 56 56"
        fill={color}
        {...props}
    >
        <g id="_x31_260-facebook_x40_2x.png_8_">
            <g>
                <path
                    d="M28,0C12.5,0,0,12.5,0,28c0,15.5,12.5,28,28,28c15.5,0,28-12.5,28-28C56,12.5,43.5,0,28,0z M36,18.3l-3.1,0
                c-2.4,0-2.9,1.1-2.9,2.8v3.6h5.7L35,30.4h-5V45h-6V30.4h-5v-5.7h5v-4.2c0-4.9,3-7.5,7.5-7.5c2.1,0,4,0.1,4.5,0.2V18.3z"
                />
            </g>
        </g>
    </svg>
)

Facebook.defaultProps = {
    color: "#fff",
}

Facebook.propTypes = {
    color: PropTypes.string,
}

export default Facebook
